import bannerImg from './banners/woman-helping-man-gym.jpg';

const leadNutricaoOnline = (t) => ({
    id: 'lead-nutricao-online',
    title: t('templates.items.leadNutricaoOnline.title'),
    description: t('templates.items.leadNutricaoOnline.description'),
    indicatedFor: t('templates.audiences.nutritionists'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.leadNutricaoOnline.summary.nameAndContact'),
        t('templates.items.leadNutricaoOnline.summary.nutritionGoal'),
        t('templates.items.leadNutricaoOnline.summary.dietHistory'),
        t('templates.items.leadNutricaoOnline.summary.availability'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.leadNutricaoOnline.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.leadNutricaoOnline.form.about.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.leadNutricaoOnline.form.about.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.leadNutricaoOnline.form.about.name.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: t('templates.items.leadNutricaoOnline.form.about.email.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: t('templates.items.leadNutricaoOnline.form.about.whatsapp.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'choices',
                        label: t('templates.items.leadNutricaoOnline.form.about.goal.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.leadNutricaoOnline.form.about.goal.options.loseWeight') },
                                { id: 'opt-2', label: t('templates.items.leadNutricaoOnline.form.about.goal.options.gainMuscle') },
                                { id: 'opt-3', label: t('templates.items.leadNutricaoOnline.form.about.goal.options.healthCondition') },
                                { id: 'opt-4', label: t('templates.items.leadNutricaoOnline.form.about.goal.options.energy') },
                                { id: 'opt-5', label: t('templates.items.leadNutricaoOnline.form.about.goal.options.reeducation') },
                            ],
                        },
                    },
                    {
                        order: 5,
                        type: 'yes_no_maybe',
                        label: t('templates.items.leadNutricaoOnline.form.about.previousFollowUp.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default leadNutricaoOnline;
